import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import App from 'app/App';
import store from 'store';

// PACKAGE STYLESHEETS
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-big-calendar/lib/sass/styles.scss';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import './index.scss';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
